var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrganiseTeam(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7277 0.347693L19.1989 3.5496C19.7259 3.77548 20.0676 4.29371 20.0676 4.86711V12.3966C20.0676 15.1741 18.7263 17.7807 16.4661 19.3951L11.7001 22.7993C10.7033 23.5113 9.3643 23.5113 8.36752 22.7993L3.60152 19.3951C1.34137 17.7807 0 15.1741 0 12.3966V4.86711C0 4.29371 0.341719 3.77548 0.868758 3.5496L8.33988 0.347693C9.42159 -0.115898 10.646 -0.115898 11.7277 0.347693Z",
    fill: "#334D6E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.7326 11.4672L8.20439 13.939C8.41511 14.1497 8.76221 14.1305 8.94838 13.8978L14.333 7.16699",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganiseTeam);
export default __webpack_public_path__ + "static/media/organiseTeam.71f38a049f1a243af21839ffd92e0045.svg";
export { ForwardRef as ReactComponent };